module.exports = __webpack_public_path__ + "img/logo.83d56985.png";